import { render, staticRenderFns } from "./TourismSidebar.vue?vue&type=template&id=e9a0b20c&"
import script from "./TourismSidebar.vue?vue&type=script&lang=js&"
export * from "./TourismSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports